import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  LOGIN_DL_VS_ROUTES_REGEX,
  ProfileSelectorFacadeService,
  SKYMILES_LOGIN
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { filter } from 'rxjs/operators';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { CreateMyPasswordFacade } from '../../data-access/login-modal/facade/create-my-password/create-my-password.facade';
import { FacadeService } from '../../data-access/login-modal/facade/facade.service';
import { ForgotLoginFacadeService } from '../../data-access/login-modal/facade/forgot-login-facade/forgot-login-facade.service';
import { ResetPasswordFacade } from '../../data-access/login-modal/facade/reset-password/reset-password.facade';
import { loginAndGetDashboardResponse } from '../../data-access/login-modal/models/login-authentication-screen.interface';
import { NextDisplayViewService } from '../../data-access/login-modal/services';
import { CoreUtilService } from '../../data-access/utils/core-util.service';
import { LoginStandaloneHelperService } from './login-standalone-helper.service';

@Component({
  selector: 'idp-standalone-login',
  templateUrl: './login-standalone.component.html',
  styleUrls: ['./login-standalone.component.css']
})
export class LoginStandaloneComponent
  extends LoginStandaloneHelperService
  implements OnInit
{
  localTesting = true;
  dashBrdResponse!: loginAndGetDashboardResponse;
  queryParamsCheck = false;

  constructor(
    public nextDisplayView: NextDisplayViewService,
    public route: ActivatedRoute,
    public router: Router,
    public loginModalFacade: FacadeService,
    public forgotLoginFacade: ForgotLoginFacadeService,
    protected resetPasswordFacade: ResetPasswordFacade,
    protected createMyPasswordFacade: CreateMyPasswordFacade,
    private profileSelectorFacadeService: ProfileSelectorFacadeService,
    private coreUtilService: CoreUtilService,
    protected analytics: AnalyticsService
  ) {
    super(
      forgotLoginFacade,
      nextDisplayView,
      createMyPasswordFacade,
      resetPasswordFacade,
      analytics
    );
  }

  ngOnInit(): void {
    this.viewPageOnRoute();
  }

  viewPageOnRoute() {
    this.getRoutePathConfig();
    this.removeDisplayNone();
    if (this.url === '' || this.url === 'login') {
      this.forgotLoginFacade.resetForm();
      this.nextDisplayView.nextDisplayView(VIEW_NAME.LOGIN_CREDENTIALS_SCREEN);
    } else if (this.routeToProfilePickerPageCheck()) {
      this.routeToProfilePickerPage();
    } else {
      this.routeLoginAssociatedPages();
    }
  }

  getRoutePathConfig() {
    const { routeConfig } = this.route.snapshot;
    const pathName = window.location.pathname.match(LOGIN_DL_VS_ROUTES_REGEX);
    const currentRoute = pathName?.find((route) => route) ?? '';
    this.url =
      this.getRoutePathConfigCheck(currentRoute) && routeConfig?.path
        ? routeConfig?.path
        : currentRoute;
  }

  checkForRefreshURL() {
    let refreshUrl = '';
    this.route.queryParams
      .pipe(filter((params) => params.refreshURL))
      .subscribe((params) => {
        refreshUrl = params.refreshURL;
      });
    return { refreshUrl };
  }

  getQueryParams() {
    const paramsArr: { [x: string]: string }[] = [];
    let bauUrl = '';
    // eslint-disable-next-line complexity
    this.route.queryParams.subscribe((params) => {
      const { queryParams, bauRefreshURL } = params;

      if (queryParams && bauRefreshURL) {
        bauUrl = bauRefreshURL;
        this.queryParamsCheck = true;
        const fieldName: string[] = [];
        const encryptedValue: string[] = [];
        const responseSplitted = queryParams.split('|');
        if (responseSplitted.length > 0) {
          responseSplitted.forEach((queryParams: string) => {
            fieldName.push(queryParams.split('=')[0]);
            encryptedValue.push(queryParams.split('=')[1]);
          });
        }

        for (let i = 0; i < fieldName.length; i++) {
          paramsArr.push({
            [fieldName[i]]: encryptedValue[i]
          });
        }
      }
    });

    const returnParams: { [key: string]: string } = Object.assign(
      {},
      ...paramsArr
    );

    return {
      returnParams,
      bauUrl
    };
  }

  routeToProfilePickerPage() {
    const data = this.getQueryParams();

    if (this.queryParamsCheck) {
      this.profileSelectorFacadeService.refreshURL = data.bauUrl;
    } else {
      this.profileSelectorFacadeService.refreshURL =
        this.checkForRefreshURL().refreshUrl;
    }

    const isAccountType =
      !!this.coreUtilService.getAccountCookie('accountType');
    if (!isAccountType) {
      this.router.navigateByUrl(SKYMILES_LOGIN);
      return;
    }
    this.profileSelectorFacadeService.fromProfileStandAlone$.next(true);
    this.profileSelectorFacadeService.assignQueryParams(data.returnParams);
  }
}
